import {StyleSheet, View, ViewStyle} from "react-native";
import {ReactNode} from "react";
import {KeyboardAwareScrollView} from "react-native-keyboard-controller";

type Props = {
    children: ReactNode,
    style?: ViewStyle,
    width?: "max" | "auto" | number,
    height?: "max" | number,
}

// Horizontal and vertical centering.
export default function Center({children, style, width, height}: Props) {
    const widthPixels = width as number;
    const heightPixels = height as number;

    return (
        <KeyboardAwareScrollView contentContainerStyle={[styles.container]}>
            <View
                style={[
                    width === undefined || width === "max" ? styles.fullWidth : {},
                    widthPixels ? {width: widthPixels, maxWidth: "100%"} : {},
                    heightPixels ? {height: heightPixels} : {},
                    {gap: 16},
                    style
                ]}>
                {children}
            </View>
        </KeyboardAwareScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: "100%",
        justifyContent: "space-around",
        alignItems: "center",
        alignContent: "center",
        margin: "auto",
    },
    fullWidth: {
        width: "100%",
    },
});